import { Info } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { ConsultButton } from "@/components/CtaButtons";
import { FinalCta } from "@/sections/HomeVoice";
import { useLanguage } from "@/i18n/LanguageContext";
import { PROCESS_STEPS } from "@/data/content";
import { IMAGES } from "@/data/images";

export default function Process() {
  const { t } = useLanguage();
  return (
    <>
      <PageHero eyebrow={t("process.eyebrow")} title={t("process.title")} image={IMAGES.site2} />
      <section className="bg-white py-24 md:py-32" data-testid="process-timeline">
        <div className="mx-auto max-w-4xl px-5 md:px-8">
          <Reveal>
            <div className="flex items-start gap-3 rounded-2xl border border-gold/30 bg-gold/[0.07] p-5" data-testid="process-placeholder-note">
              <Info className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" />
              <p className="text-sm leading-relaxed text-charcoal/70">{t("process.note")}</p>
            </div>
          </Reveal>
          <div className="relative mt-16 space-y-10 before:absolute before:bottom-4 before:left-[23px] before:top-4 before:w-px before:bg-charcoal/10">
            {PROCESS_STEPS.map((step, i) => (
              <Reveal key={step.id} delay={0.04 * i}>
                <div className="relative flex gap-7" data-testid={`process-step-${step.id}`}>
                  <div className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-gold/50 bg-white font-display text-lg text-gold-dark">
                    {i + 1}
                  </div>
                  <div className="flex-1 rounded-2xl border border-charcoal/10 bg-offwhite p-7 transition-[border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-gold-dark/40">
                    <h2 className="font-display text-2xl text-charcoal">{step.name}</h2>
                    <p className="mt-2.5 text-sm leading-relaxed text-charcoal/65">{step.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-16 text-center">
            <ConsultButton testid="process-consult-button" />
          </Reveal>
        </div>
      </section>
      <FinalCta />
    </>
  );
}
